<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

               <v-card>

                   <v-breadcrumbs divider="/">
                       <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                       <v-breadcrumbs-item :disabled="true">Pod grupa</v-breadcrumbs-item>
                   </v-breadcrumbs>

               </v-card>

                <v-card class="m-20" v-if="attributes">

                    <v-card-title>

                        <v-layout>

                            <v-flex xs4 pr-4>

                                <v-select
                                        @change="getAttributes()"
                                        :items="properties"
                                        label="Grupa"
                                        v-model="search"
                                        item-text="title"
                                        item-value="id"
                                ></v-select>

                            </v-flex>


                        </v-layout>

                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="attributes"
                            :pagination.sync="pagination"
                            :total-items="total_attributes"
                            :loading="loading"
                            :rows-per-page-items=[50,25,10]
                            rows-per-page-text="redova po strani"
                            class="elevation-1"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.id }}</td>
                            <td class="text-xs-left">{{ props.item.title }}</td>
                            <td class="text-xs-left">{{ props.item.property.title }}</td>
                            <td class="text-xs-left">{{ props.item.is_visible }}</td>
                            <td class="text-xs-left">{{ props.item.created_at }}</td>
                            <td class="text-xs-right">

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="secondary" class="black&#45;&#45;text" :to="'/users/' + props.item.id + '/edit'" v-if="checkGuard('user-edit')">-->
                                    <v-btn slot="activator" small color="secondary" class="black--text" :to="'/attributes/' + props.item.id + '/edit'">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span>Izmeni</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="error" @click="destroy(props.item)" v-if="checkGuard('user-delete')">-->
                                    <v-btn slot="activator" small color="error" @click="destroy(props.item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    <span>Obriši</span>
                                </v-tooltip>

                            </td>
                        </template>

                    </v-data-table>

                </v-card>

            </v-flex>

            <!--<v-fab-transition v-if="checkGuard('user-create')">-->
            <v-fab-transition>

                <v-btn :color="'primary'" dark fab fixed bottom right to="/attributes/create">
                    <v-icon>playlist_add</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>

            </v-fab-transition>


        </v-layout>
    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                total_attributes: 0,
                loading: true,
                search: 0,
                pagination: {
                    descending: true,
                },
                attributes: false,
                properties: false,
                headers: [
                    {text: 'ID', align: 'left', sortable: true, value: 'id'},
                    {text: 'NAZIV', align: 'left', sortable: true, value: 'name'},
                    {text: 'GRUPA', sortable: true, value: 'property_id'},
                    {text: 'VIDLJIVO', sortable: true, value: 'is_visible'},
                    {text: 'KREIRANO',sortable: false,  value: 'created_at'},
                    {text: 'AKCIJA', align: 'right', value: 'action'},
                ],
            }
        },
        mounted() {
            this.getAttributes();
            this.getProperties();
        },
        computed: {
            user(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getAttributes() {
                this.loading = true;
                const { sortBy, descending, page, rowsPerPage } = this.pagination;

                axios.get(`attributes?${sortBy}=1&page=${page}&DESC=${descending? 1 : 0}&paginate=${rowsPerPage}&property_id=${this.search}`)
                    .then(res => {
                        this.attributes = res.data.attributes.data;
                        this.total_attributes = res.data.attributes.total;
                        this.loading = false;
                    }).catch(e => {
                        console.log(e.response);
                        this.error = e.response.data.errors;
                    });
            },
              getProperties(){
                axios.get('properties/lists')
                  .then(res => {
                    this.properties = res.data.properties;
                  })
                  .catch(e => {
                    console.log(e);
                    this.error = e.response.data.errors;
                  });
              },
            destroy(row){
                swal({
                    title: 'Da li ste sigurni?',
                    text: 'Nećete moći da povratite radnju',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: this.$vuetify.theme.primary,
                    cancelButtonColor: this.$vuetify.theme.secondary,
                    confirmButtonText: 'Da, obriši.',
                    cancelButtonText: 'Odustani',
                }).then((result) => {
                    if (result.value) {
                        axios.delete('attributes/' + row.id)
                            .then(res => {
                                this.getAttributes();
                                swal(
                                    'Obrisano',
                                    'Uspešno ste obrisali',
                                    'success',
                                );
                            })
                            .catch(e => {
                                console.log(e);
                            });
                    }
                });
            },
            checkGuard(name){
                let res = false;
                let permissionList = this.$store.getters['ability/getPermissionList'];
                permissionList.forEach(permission => {
                    if(name === permission.name){
                        res = true;
                    }
                });
                return res;
            },
        },
        watch: {
            pagination: {
                handler () {
                    this.getAttributes();
                },
                deep: true
            },
        },
    }
</script>

<style scoped>
    .swal2-styled.swal2-confirm{
        border-radius: 0 !important;
    }
</style>
